/**
 * RentIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const RentIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="m16.495 5.667 5 5c2 2 2 5.25 0 7.25l-.25.25c-2 2-5.25 2-7.25 0l-3.21-3.21c-.19.15-.37.28-.57.41v4.41c0 .56-.22 1.1-.62 1.49l-1.11 1.11c-.82.82-2.16.82-2.98 0l-1.11-1.12c-.39-.4-.61-.93-.61-1.49v-4.4c-1.66-1.06-2.78-2.91-2.78-5.04 0-2.99 2.2-5.47 5.08-5.91a4.04 4.04 0 0 1 3.99-3.41c2.03 0 3.7 1.5 3.99 3.45.89.13 1.74.52 2.43 1.21m-4.42-1.04c-.2-.93-1.02-1.63-2.01-1.63v.01c-.92 0-1.69.61-1.95 1.44.9.16 1.73.54 2.44 1.06.46-.41.97-.7 1.52-.88m-3.85 10.16c0-.41.25-.77.61-.92l.01-.01c1.29-.67 2.17-2 2.17-3.54 0-1.86-1.28-3.41-3-3.86v3.1c.16.21.28.47.28.76 0 .71-.57 1.28-1.28 1.28s-1.28-.56-1.28-1.27c0-.29.12-.55.28-.76v-3.1c-1.72.45-3 2-3 3.86 0 1.54.88 2.87 2.17 3.54.34.14.59.47.61.86v5.04c0 .03.03.08.03.08l1.11 1.12c.04.04.11.04.15 0l1.11-1.11c.02-.02.03-.08.03-.08zm11.61 1.97.25-.25-.01-.01a3.126 3.126 0 0 0 0-4.42l-5.01-5.01c-.86-.86-2.21-.9-3.13-.14.67.97 1.06 2.14 1.06 3.4 0 1.15-.33 2.21-.89 3.12l3.31 3.31a3.126 3.126 0 0 0 4.42 0"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const RentIcon = makeIcon('RentIcon', RentIconSvg)
